import { useState, useEffect } from "react";
import styles from "./styles.module.scss";

export default function StorageActions() {
  const [isManageLocalStorageOpen, setIsManageLocalStorageOpen] =
    useState(false);
  const [localData, setLocalData] = useState([]);

  const handleManageLocalStorage = () => {
    const localData = localStorage.getItem("transcripts");
    const localDataParsed = JSON.parse(localData);
    setLocalData(localDataParsed);
  };

  const handleDeleteLocalStorage = (item) => {
    localStorage.removeItem(item.id);
    const filteredData = localData.filter((data) => data.id !== item.id);
    setLocalData(filteredData);
    localStorage.setItem("transcripts", JSON.stringify(filteredData));
    setIsManageLocalStorageOpen(false);
    window.location.reload();
  };

  const handleClearLocalStorage = () => {
    localStorage.clear();
    setLocalData([]);
    setIsManageLocalStorageOpen(false);
    window.location.reload();
  };

  useEffect(() => {
    handleManageLocalStorage();

    return () => {
      setLocalData([]);
    };
  }, []);

  return (
    <div className={styles.storageActionsWrapper}>
      <button
        type="button"
        className={styles.editLocalStorage}
        onClick={() => {
          handleManageLocalStorage();
          setIsManageLocalStorageOpen(true);
        }}
      >
        <img src={"/icons/editing.svg"} width={20} alt="Manage Local Storage" className={localData?.length > 4 ? styles.pulse : ""}/>
        <span>Manage Local Storage</span>
      </button>
      {isManageLocalStorageOpen && (
        <div className={styles.manageLocalStorage}>
          <div className={styles.manageLocalStorageCard}>
            <div className={styles.manageLocalStorageCardHeader}>
              <h2>Manage Local Storage</h2>
              <div className={styles.manageLocalStorageCardHeaderActions}>
                <button
                  type="button"
                  className={styles.button}
                  onClick={() => handleClearLocalStorage()}
                >
                  <img
                    src={"/icons/broom.svg"}
                    width={20}
                    alt="Clear Local Storage"
                  />
                  <span>Clear All</span>
                </button>
                <button
                  type="button"
                  className={styles.buttonX}
                  onClick={() => setIsManageLocalStorageOpen(false)}
                >
                  <span>x</span>
                </button>
              </div>
            </div>
            <div className={styles.manageLocalStorageContent}>
              {localData?.map((item) => (
                <div className={styles.manageLocalStorageItem} key={item.id}>
                  <div>{item.id}</div>
                  <div>{item.title}</div>
                  <div>{item.status}</div>
                  <div className={styles.manageLocalStorageItemActions}>
                    <button
                      type="button"
                      onClick={() =>
                        (window.location.href = `/transcripts/${item.id}`)
                      }
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      onClick={() => handleDeleteLocalStorage(item)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
